import { useExternalRowSelectionApi } from './useExternalRowSelectionApi';
import { useRef } from 'react';

export const useExternalRowSelectionClearOnChange = <T>({ rows }: { rows: T[] }) => {
  const { unSelectAll } = useExternalRowSelectionApi();

  const prevRows = useRef<T[]>([]);
  if (prevRows.current !== rows) {
    unSelectAll();
    prevRows.current = rows;
  }
};
